




























































































































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import ComEmpty from '@/components/com-empty.vue';
// 相当于objectC的.h 声明文件，用于定义数据结构
import { ClassAndTypeParams, ClassObject } from './classListInterface';

const user = namespace('user');
const lessonDialogModule = namespace('lessonDialog');

@Component({
  components: {
    ComEmpty,
  },
  filters: {
    doubleTeachOrAI(type: number) {
      // 双师类型
      const ShuangshiClassType = [1, 2, 4, 5, 15, 16];
      // AI类型
      const AIClassType = [6, 7, 17, 18];
      if (ShuangshiClassType.includes(type)) {
        return '双师';
      } if (AIClassType.includes(type)) {
        return 'AI';
      }
      return '';
    },
  },
})
export default class ClassList extends Vue {
  // 引入vuex数据
  @user.State('userInfo') userInfo: any;

  @lessonDialogModule.Action('getLessons') getLessons: any

  @lessonDialogModule.Mutation('updateCurrentClass') updateCurrentClass: any

  @lessonDialogModule.Mutation('updateVisible') updateVisible: any

  myClassAndTypeList: any[] = [];

  classesParams: any = {};

  labelResource: any = {
    1: '自研',
    2: '三阶课',
    3: '短线课',
    4: '公开课',
    5: '双师',
    6: 'AI',
    7: '超级课件',
  }

  // 请求列表数据
  private getMyClassAndType(params: ClassAndTypeParams) {
    this.classesParams = params;
    this.$service.bk.getMyClassAndType(params).then((result: any) => {
      if ((result && result.allSize === 0) || !result) {
        this.$router.push({
          path: '/index',
        });
      } else {
        this.myClassAndTypeList = result.list;
        // 如果有labels 先排序
        this.myClassAndTypeList.forEach((item) => {
          if (item.labels) {
            item.labels.sort();
          }
        });
        this.$nextTick(() => {
          this.$bus.$emit('showGuide', 'myClass');
        });
      }
    });
  }

  private handleShowLessonDialog(classType: any) {
    if (classType.classTypeStatus === 0) {
      this.$toast.show('抱歉当前班型已禁用');
    } else {
      const data = {
        businessId: classType.type === 1 ? classType.classId : classType.classTypeId,
        type: classType.type, // 类型：1,班级;2,班型
        newDiyFlag: classType.newDiyFlag, // 新老diy 0老diy   1新diy
      };

      const currentClass = {
        ...classType,
        businessId: classType.type === 1 ? classType.classId : classType.classTypeId,
      };
      this.getLessons(data).then(() => {
        this.updateCurrentClass(currentClass);
        this.updateVisible(true);
      });
    }
  }

  // 点击删除
  private handleDel(classType: any) {
    this.$utils.sendAction('index', 'history', 'id-2');
    this.$service.bk.delClassType(classType.classTypeId)
      .then(() => {
        this.$toast.show('删除成功');
        this.getMyClassAndType(this.classesParams);
      });
  }

  private getClassObject<T extends { period: number }>(item: T): ClassObject {
    return {
      chun: item.period === 1,
      shu: item.period === 2,
      qiu: item.period === 3,
      han: item.period === 4,
    };
  }

  // 监听筛选条件改变事件:parmasChange，请求列表数据
  private watchParams() {
    this.$bus.$on('parmasChange', this.getMyClassAndType);
  }

  get isDt(): boolean {
    const { roles } = this.userInfo;
    return roles.indexOf('dt_assistant') !== -1;
  }

  get isManage(): boolean {
    const { roles } = this.userInfo;
    return (
      roles.indexOf('manage') !== -1 || roles.indexOf('super_manager') !== -1
    );
  }

  get isTeacher(): boolean {
    const { roles } = this.userInfo;
    return roles.indexOf('teacher') !== -1;
  }

  mounted() {
    this.watchParams();
  }
}
